import { appConstants } from "../../constants/app_constants"

const AppLogo = () => {
    let logoDark = appConstants.lfLogoDark

    return (
        <div className="loading-container">
            <img src={logoDark} alt="" />
        </div>
    )
}

export default AppLogo